<template>
  <!-- eslint-disable max-len -->
  <svg
    :aria-labelledby="iconName"
    :height="height"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 38 29"
  >
    <path
      d="M13.1641 27.4375C13.8672 28.1406 15.0625 28.1406 15.7656 27.4375L36.4375 6.76562C37.1406 6.0625 37.1406 4.86719 36.4375 4.16406L33.9062 1.63281C33.2031 0.929688 32.0781 0.929688 31.375 1.63281L14.5 18.5078L6.55469 10.6328C5.85156 9.92969 4.72656 9.92969 4.02344 10.6328L1.49219 13.1641C0.789062 13.8672 0.789062 15.0625 1.49219 15.7656L13.1641 27.4375Z"
      fill="white"
    />
  </svg>
</template>

<script>
import BaseIcon from 'mixins/BaseIcon';

export default {
  mixins: [BaseIcon]
};
</script>
